export const ERROR_ON_PROPOSER_DETAILS =
  'Encountered an error while fetching proposer details.'

export const DETAILS_SUBMITTED_SUCCESFULLY =
  'Your details have been saved successfully.'

export const ERROR_SENDING_DATA = 'Error while sending data. Please try again.'

export const ENCOUNTERED_ERROR_POCILY_DETAILS =
  'Encountered an error while fetching policy details manually.'

export const PLEASE_FILL_REQ_DETAILS = 'Please fill the required details.'

export const RELATION = {
  SPOUSE: 'SPOUSE',
}

export const ENCOUNTERED_MEDICAL_QUESTIONS =
  'Encountered an error while fetching medical questions.'

export const CONTINUE = 'Continue'

export const NEXT = 'Next'

export const FAILURE = 'Failure'

export const STEPPER_CONSTANTS = {
  HEALTH: 'health',
  INSURANCE_DETAILS: 'insuranceDetails',
  PLAIN_DETAILS: 'plan-details',
  MEMBER_DETAILS: 'member-details',
  MEDICAL_CONDITION: 'medical-condition',
}

export const INVALID_MOBILE = 'Invalid phone number'

export const PHONE = 'phone'

export const HEALTH = 'Health'

export const FORM_ERRORS = {
  NAME: 'Invalid name. Please enter a valid name.',
  EMAIL: 'Invalid email. Please enter a valid email address.',
  PHONE: 'Invalid phone number. Please enter a valid phone number.',
  AGE: 'Please select at least one insured person and enter age to continue.',
  GENDER: 'Please select the gender to continue.',
  AGE_GENDER:
    'Please select the gender and at least one insured person and enter age to continue.',
  MANDATORY_FIELDS: 'Please fill out the highlighted mandatory fields.',
  PINCODE: 'Please enter a valid pincode',
}

export const COVERAGE_TABS = {
  TOP: { id: 'topCoverages', label: 'Top Coverages' },
  WAITING: { id: 'waitingCoverages', label: 'Waiting Coverages' },
  VALUE_ADDED: { id: 'valueAddedCoverages', label: 'Value Added Coverages' },
  ADDITIONAL: { id: 'additionalCoverages', label: 'Additional Coverages' },
  CONDITIONAL: { id: 'conditionalCoverages', label: 'Conditions' },
}
